
export const calculateNextReviewDueDate = (lastReviewedAt, reviewCycle, createdAt) => {
  if (!reviewCycle) return null;

  if (!lastReviewedAt) return null;

  let baseDate = null;

  if (typeof lastReviewedAt === "string" && /^\d+$/.test(lastReviewedAt)) {
    baseDate = new Date(Number(lastReviewedAt));
  } else if (typeof lastReviewedAt === "number") {
    baseDate = new Date(lastReviewedAt);
  } else if (typeof lastReviewedAt === "string" && !isNaN(Date.parse(lastReviewedAt))) {
    baseDate = new Date(lastReviewedAt);
  }

  // If lastReviewedAt is invalid, return null
  if (!baseDate || isNaN(baseDate.getTime())) return null;

  const nextReviewDate = new Date(baseDate);
  nextReviewDate.setDate(nextReviewDate.getDate() + Number(reviewCycle));

  return nextReviewDate;
};

